import { fetchApi } from "@/utils/axios";
import http from "@/utils/axios";

const BASE_URL = '/api/dscloud-app-forum/web/survey/questionnaire';

// 问卷列表 - POST data
export const getQuestionnaireList = (data) => {
  return fetchApi(BASE_URL + '/list', data, 'POST', 'data');
};

// 新增问卷 - POST data
export const createQuestionnaire = (data) => {
  return fetchApi(BASE_URL + '/create', data, 'POST', 'data');
};

// 问卷详情 - GET params (id)
export const getQuestionnaireDetail = (id) => {
  return fetchApi(BASE_URL + '/detail', { id }, 'GET', 'params');
};

// 编辑问卷 - PUT data
export const updateQuestionnaire = (data) => {
  return fetchApi(BASE_URL + '/update', data, 'PUT', 'data');
};

// 结束问卷 - PUT params (id)
export const endQuestionnaire = (id) => {
  return fetchApi(BASE_URL + '/end/?id=' + id, null, 'PUT', 'params');
};

// 删除问卷 - DELETE params (id)
export const deleteQuestionnaire = (id) => {
  return fetchApi(BASE_URL + '/delete/?id=' + id, null, 'DELETE', 'params');
};

// 导出问卷数据 - GET params (id)，使用http以支持blob响应
export const exportQuestionnaireData = (id) => {
  return http({
    url: BASE_URL + '/export',
    method: 'get',
    params: { id },
    responseType: 'blob',
    timeout: 120000
  });
};

// 级联问题 - 获取层级字典树
export const getCascadeDictTree = () => {
  return fetchApi('/api/dscloud-app-forum/web/common/hierarchy-dict/tree', null, 'GET', 'params');
};
